import { fetchProgramSection } from "@client";
import { useQuery, UseQueryOptions } from "@tanstack/react-query";

export const fetchProgramSectionQueryKey = "fetchProgramSectionQueryKey";

export const useFetchProgramSectionQuery = (
  programId: string,
  sectionId: string,
  enabled?: boolean,
) => {
  const { data, ...rest } = useQuery({
    queryKey: [fetchProgramSectionQueryKey, programId, sectionId],
    queryFn: () => fetchProgramSection(programId, sectionId),
    enabled,
  });

  return {
    data: data?.data,
    ...rest,
  };
};
